import React, { useEffect} from 'react';



const FullscreenDialog = ({ isOpen, onClose, children, title }) => {
    useEffect(() => {
        if (isOpen) {
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
    
        return () => {
          document.body.classList.remove('overflow-hidden');
        };
      }, [isOpen]);
    
      if (!isOpen) return null;

  return (
<div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm">
  <div className="fixed inset-5 rounded-3xl bg-gray-950/95 border border-gray-300/20 shadow-lg shadow-black flex flex-col">
    {/* Close button */}
    <button
      onClick={onClose}
      className="absolute top-4 right-4 text-5xl text-gray-600 hover:text-white"
    >
      &times;
    </button>

    {/* Title */}
    <h1 className="font-bold text-cyan-700 text-6xl font-panther w-full border-b border-cyan-900 px-6 pt-6 pb-4 shrink-0">
      {title}
    </h1>

    {/* Scrollable content */}
    <div className="flex-1 overflow-y-auto p-6 mb-6 px-12 mx-4 custom-scrollbar">
      {children}
    </div>
  </div>
</div>

  );
};

export default FullscreenDialog;
